export const CLASS_NAMES = {
  AREA_COLLAPSE: "areaCollapse",
} as const;
